document.addEventListener("DOMContentLoaded", () => {
    const btnCheckout = document.querySelector('button[name="checkout"]');
    
    if (btnCheckout) {
        btnCheckout.addEventListener("click", () => {
            btnCheckout.style.setProperty("pointer-events", "none", "important");
        });
    }

  const inputSearch = document.querySelector(`.search-bar__input[name="q"]`);
  if (!inputSearch) return;

  let debounceTimer;
  inputSearch.addEventListener("input", (e) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 300);
  });

});
